import React, { useEffect, useState } from "react";
import {
  Iconography,
  IconographySizes,
  Link,
} from "@hid-galaxy-ui/galaxy-react";
import { MenuItem, Select } from "@mui/material";
import { useAppSelector } from "../../../../../../../redux";
import ActivityDescriptionModal from "../../../../../../../common/components/partner-program/ActivityDescriptionModal";
import ActivityDescriptionLink from "../../../../../../../common/components/partner-program/ActivityDescriptionLink";

interface MarketingActivity {
  name: string;
  level: string;
  accelerator: string;
  potential: string;
  comment: string;
  action: string | null;
  status: "Accepted" | "Rejected" | null;
}

interface EngagementActivitesProps {
  selectedAssesmentData: any;
  isEditable?: boolean;
  engagementEditData?: any[] | null;
  onEngagementSelectChange?: (
    mainIndex: number,
    subIndex: number,
    value: any,
    accelerator_value: any
  ) => void;
  onOpenEngagementComment?: (
    mainIndex: number,
    subIndex: number,
    item: any
  ) => void;
}

const EngagementActivitiesSection: React.FC<EngagementActivitesProps> = ({
  selectedAssesmentData,
  isEditable = false,
  engagementEditData = null,
  onEngagementSelectChange,
  onOpenEngagementComment,
}) => {

  const [engagementData,setEngagementData]=useState(null);
  const [descriptionModal, setDescriptionModal] = useState<{
    open: boolean;
    activityName: string;
    description: string;
  }>({
    open: false,
    activityName: "",
    description: "",
  });

    const {
      partnerEngagementCategoryList } = useAppSelector(
        (state) => state.partner_engagementConfiguration
      );

      useEffect(()=>{


        if(selectedAssesmentData && selectedAssesmentData.engagements &&
          selectedAssesmentData.engagements.length && partnerEngagementCategoryList &&
          partnerEngagementCategoryList.length
        ){
const deepClone = structuredClone(selectedAssesmentData.engagements);
          deepClone.map((a_data:any,index:number)=>{

           const existCategory= partnerEngagementCategoryList.find((c_data:any)=>{
              return c_data.ID===a_data.category_id
            })

            if(existCategory){
 a_data.category_name=existCategory.category_name
            }else{
             a_data.category_name='No Category'
            }

            // Resolve Level and Accelerator from engagement config (same as calculator)
            // getPartnerPoints API may return activity_key/activity_value in different format;
            // use partnerEngagementCategoryList.engagements[].accelerator_value for correct display
            const configEngagement = existCategory?.engagements?.find((e: any) => e.ID === a_data.activity_id);
            if (configEngagement?.accelerator_value?.length) {
              const activityVal = a_data.activity_value;
              const option = configEngagement.accelerator_value.find(
                (opt: { option_key: string; option_value: any }) =>
                  String(opt.option_value) === String(activityVal) || opt.option_key === activityVal
              );
              if (option) {
                a_data.levelDisplay = option.option_key;
                a_data.acceleratorDisplay = option.option_value;
              }
            }
            if (a_data.levelDisplay == null) a_data.levelDisplay = a_data.activity_key;
            if (a_data.acceleratorDisplay == null) a_data.acceleratorDisplay = a_data.activity_value;
            if (configEngagement?.description) {
              a_data.description = configEngagement.description;
            }

          })

          const assesmentByCategoryName = deepClone.reduce((acc:any, person:any) => {
  const category_name = person.category_name;
  // Still need to check if the key exists
  if (!acc[category_name]) acc[category_name] = [];

  acc[category_name].push(person);

  return acc;
}, {});

setEngagementData(assesmentByCategoryName);

        }

      },[selectedAssesmentData, partnerEngagementCategoryList])

 const [expanded, setExpanded] = useState('');
  const [oldExpandKey, setOldExpanded] = useState('');

  const engagementActivities = [
    { key: "commercial", label: "Commercial", hasIndicator: true, count: 2 },
    { key: "loyalty", label: "Loyalty", hasIndicator: false, count: null },
    {
      key: "marketing",
      label: "Marketing Engagement",
      hasIndicator: false,
      count: null,
    },
    { key: "events", label: "Events", hasIndicator: false, count: null },
    {
      key: "integration",
      label: "Integration",
      hasIndicator: false,
      count: null,
    },
    {
      key: "miscellaneous",
      label: "Miscellaneous",
      hasIndicator: false,
      count: null,
    },
  ];

  const marketingActivities: MarketingActivity[] = [
    {
      name: "Case study",
      level: "Select",
      accelerator: "0.4",
      potential: "1.5",
      comment: "Comment",
      action: "Assign or next partner certification",
      status: null,
    },
    {
      name: "Blog posts",
      level: "Select",
      accelerator: "0.4",
      potential: "1.5",
      comment: "Comment",
      action: null,
      status: "Accepted",
    },
    {
      name: "Partner web page",
      level: "Select",
      accelerator: "0.4",
      potential: "1.5",
      comment: "Comment",
      action: null,
      status: "Rejected",
    },
    {
      name: "Social media",
      level: "Select",
      accelerator: "0.4",
      potential: "1.5",
      comment: "Comment",
      action: null,
      status: null,
    },
  ];

  const toggleEngagement = (key: string) => {
    if (key === oldExpandKey) {
      setExpanded("");
      setOldExpanded("");
    } else {
      setExpanded(key);
      setOldExpanded(key);
    }
  };

  const editTotalCount =
    engagementEditData?.reduce(
      (n, c) => n + (c.engagements?.length || 0),
      0
    ) ?? 0;

  const openDescriptionModal = (payload: {
    activityName?: string;
    description?: string;
  }) => {
    setDescriptionModal({
      open: true,
      activityName: payload.activityName || "",
      description: payload.description || "",
    });
  };

  const closeDescriptionModal = () => {
    setDescriptionModal({
      open: false,
      activityName: "",
      description: "",
    });
  };

  if (isEditable && engagementEditData && engagementEditData.length) {
    return (
      <>
        <div className="section-header">
          <div>
            <span className="section-title">Engagement Activities</span>
            <span className="section-subtitle">Configure Activity Points</span>
          </div>
          <div className="activity-badges">
            <span className="badge total">Total: {editTotalCount}</span>
            <span className="badge done">Done: {editTotalCount}</span>
            <span className="badge pending">Pending: 0</span>
          </div>
        </div>
        <div className="engagement-list">
          {engagementEditData.map((activity: any, main_index: number) => (
            <React.Fragment key={activity.category_name || main_index}>
              {activity.engagements?.length ? (
                <div className="engagement-wrapper">
                  <div
                    className={`engagement-item ${
                      expanded === activity.category_name ? "expanded" : ""
                    }`}
                    onClick={() => toggleEngagement(activity.category_name)}
                  >
                    <div className="item-left">
                      <div className="title-wrapper">
                        <span className="item-title">{activity.category_name}</span>
                      </div>
                    </div>
                    <Iconography
                      icon={
                        expanded === activity.category_name
                          ? "chevronUp"
                          : "chevronDown"
                      }
                      size={IconographySizes.Small}
                      className="chevron-icon"
                    />
                  </div>
                  {expanded === activity.category_name && (
                    <div className="engagement-content">
                      <div className="engagement-table">
                        <div className="table-header">
                          <div className="th th-activity">Activity Name</div>
                          <div className="th th-description">Description</div>
                          <div className="th th-level">Level</div>
                          <div className="th th-accelerator">Accelerator</div>
                          <div className="th th-potential">Potential</div>
                          <div className="th th-comment">Comment</div>
                        </div>
                        <div className="table-body">
                          {activity.engagements.map((item: any, index: number) => (
                            <div key={index} className="table-row">
                              <div className="td td-activity">
                                {item.activity_name}
                              </div>
                              <div className="td td-description">
                                <ActivityDescriptionLink
                                  activityName={item.activity_name}
                                  description={item.description}
                                  onView={openDescriptionModal}
                                />
                              </div>
                              <div className="td td-level">
                                <Select
                                  className="selctWd"
                                  value={item.selectedValue}
                                  onChange={(e) => {
                                    onEngagementSelectChange?.(
                                      main_index,
                                      index,
                                      e.target.value,
                                      item.accelerator_value
                                    );
                                  }}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  {item.accelerator_value?.length ? (
                                    item.accelerator_value.map(
                                      (a_data: any, ind: number) => (
                                        <MenuItem key={ind} value={a_data.option_value}>
                                          {a_data.option_key}
                                        </MenuItem>
                                      )
                                    )
                                  ) : (
                                    <MenuItem>No Data</MenuItem>
                                  )}
                                </Select>
                              </div>
                              <div className="td td-accelerator">
                                {item.selectedValue}
                              </div>
                              <div className="td td-potential">
                                {item.potential_improvement}
                              </div>
                              <div className="td td-comment">
                                <Link
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    onOpenEngagementComment?.(
                                      main_index,
                                      index,
                                      item
                                    );
                                  }}
                                >
                                  Comment
                                </Link>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ) : null}
            </React.Fragment>
          ))}
        </div>
        <ActivityDescriptionModal
          open={descriptionModal.open}
          onClose={closeDescriptionModal}
          activityName={descriptionModal.activityName}
          description={descriptionModal.description}
        />
      </>
    );
  }

  return (
    <>
      <div className="section-header">
        <div>
          <span className="section-title">Engagement Activities</span>
          <span className="section-subtitle">Configure Activity Points</span>
        </div>
        <div className="activity-badges">
          <span className="badge total">Total: 20</span>
          <span className="badge done">Done: 18</span>
          <span className="badge pending">Pending: 2</span>
        </div>
      </div>
      <div className="engagement-list">
        {engagementData!=null && Object.keys(engagementData).map((key:any, value) =>(
          <div key={key} className="engagement-wrapper">
            <div
              className={`engagement-item ${
                expanded[key] ? "expanded" : ""
              }`}
              onClick={() => toggleEngagement(key)}
            >
              <div className="item-left">
                <div className="title-wrapper">
                  <span className="item-title">{key}</span>
                  {/* {activity.count && (
                    <span className="red-badge">{activity.count}</span>
                  )} */}
                </div>
              </div>
              <Iconography
                icon={expanded===key ? "chevronUp" : "chevronDown"}
                size={IconographySizes.Small}
                className="chevron-icon"
              />
            </div>

            {/* Expanded Content - Marketing Engagement Table */}
           {expanded === key &&
              <div className="engagement-content">
                <div className="engagement-table">
                  <div className="table-header">
                    <div className="th th-activity">Activity Name</div>
                    <div className="th th-description">Description</div>
                    <div className="th th-level">Level</div>
                    <div className="th th-accelerator">Accelerator</div>
                    <div className="th th-potential">Potential</div>
                    <div className="th th-comment">Comment</div>
                    {/* <div className="th th-action">
                      Action
                      <div className="info-icon-wrapper">
                        <Iconography
                          icon="circleInfo"
                          size={IconographySizes.Small}
                          className="info-icon"
                        />
                        <div className="info-tooltip">
                          Accept or reject partner filled information
                        </div>
                      </div>
                    </div> */}
                  </div>
                  <div className="table-body">
                    {engagementData && engagementData[key] ?
                    engagementData[key].map((item:any, index:number) => (
                      <div key={index} className="table-row">
                        <div className="td td-activity">{item.activity_name || item.name}</div>
                        <div className="td td-description">
                          <ActivityDescriptionLink
                            activityName={item.activity_name || item.name}
                            description={item.description}
                            onView={openDescriptionModal}
                          />
                        </div>
                        <div className="td td-level">
                         {item.levelDisplay ?? item.activity_key}
                        </div>
                        <div className="td td-accelerator">
                          {item.acceleratorDisplay ?? item.activity_value}
                        </div>
                        <div className="td td-potential">{item.potential_improvement}</div>
                       <div className="td td-comment">
                            {item && item.comment && item.comment.length ?
                              <button className="comment-btn">
                                {item?.comment[0]?.comment || '-'}
                              </button> : <span className="t-center">-</span>
                            }
 
                          </div>
                        <div className="td td-action">
                          {/* {item.action && ( */}
                            {/* // <button className="action-btn">
                            //   {item.action}
                            // </button>
                            // <div className="activity-badges">
                            //             <span className="badge done">
                            //               {item?.action || 'Approved'}
                            //                </span>
                            // </div> */}
                          {/* // )} */}
                          {/* {item.status === "Accepted" && (
                            <button className="status-btn accepted">
                              Accepted
                            </button>
                          )}
                          {item.status === "Rejected" && (
                            <button className="status-btn rejected">
                              Rejected
                            </button>
                          )}
                          {!item.status && !item.action && (
                            <div className="action-icons">
                              <button className="icon-btn check">
                                <Iconography
                                  icon="check"
                                  size={IconographySizes.Small}
                                />
                              </button>
                              <button className="icon-btn cross">
                                <Iconography
                                  icon="xmark"
                                  size={IconographySizes.Small}
                                />
                              </button>
                            </div>
                          )} */}
                        </div>
                      </div>
)) : engagementData[key]}
                  </div>
                </div>
              </div>
}
          </div>
        ))}
        
      </div>
      <ActivityDescriptionModal
        open={descriptionModal.open}
        onClose={closeDescriptionModal}
        activityName={descriptionModal.activityName}
        description={descriptionModal.description}
      />
    </>
  );
};

export default EngagementActivitiesSection;
